import getLocalString from "constants/Localization";
import { useCustomAddProductsToProposalStageMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCustomAddProductsToProposalStage() {
  const [mutation, { loading, error, data }] = useCustomAddProductsToProposalStageMutation({
    refetchQueries: ["customGetProposal"],
  });
  const [customAddProductsToProposalStage, context] = useBitumioMutation(
    {
      mutation,
      loading,
      error,
      data,
      key: "addProductsToProposalStage",
    },
    {
      successMessage: getLocalString("proposals.add-products-to-proposal-stage-success"),
      failureMessage: getLocalString("proposals.add-products-to-proposal-stage-failure"),
    }
  );

  return [customAddProductsToProposalStage, context] as const;
}
